/*
* Receives a number and locale
* And converts it to an internationally formatted number string
*/
function formatIntlNumber(number: number, locale: string): string {
    return new Intl.NumberFormat(locale).format(number);
}

export {formatIntlNumber};